/*
 *  Product Template Scripts
 *    Scripts that are only meant to run on the Product Template.
 *
 *  Version:
 *    1.0.0 - 2023/07/14
 */
import $ from 'jquery';

import '../sections/ProductGallery';
import '../sections/ProductRecommendations';

import { Swatch, ON_VARIANT_CHANGE } from "./../objects/swatch/Swatch";
import { printMoney, t, cartAdd } from '@process-creative/slate-theme-tools';

import BackInStockDrawer, {SELECTOR_DRAWER} from '../components/product/back-in-stock-drawer';
import { CLASS_HIDDEN } from '../sections/ProductRecommendations';

const PRODUCT_TEMPLATE_CONTAINER = "[data-product-template]";
const PRODUCT_MONEY = "[data-product-money]";
const PRODUCT_COMPARE_MONEY = "[data-product-compare-money]";
const PRODUCT_ALTERNATE_PAYMENT_MONEY = "[data-alternate-money-price]";
const STOCK_NOTICE_SELECTOR = "[data-product-stock-notice]";
const SOLD_OUT_SELECTOR = "[data-sold-out]";
const BIS_NOTIFY_BTN = '[data-back-in-stock-drawer-open-btn]';
const SELECTOR_BUY_OPTIONS = `[data-buy-options]`;
const SELECTOR_ALTERNATE_METHODS = `[data-alternate-methods]`;
const SELECTOR_CONFIGURATION = '[data-configuration-selector]';
const ATTR_SELECTED_VARIANT = 'data-selected-variant';

const CLASS_VISIBLE = "is-visible";
const CLASS_IS_HIDDEN = 'is-hidden';


class ProductTemplate {
  
  constructor(container) {


    this.container = container;

    $(() => BackInStockDrawer($(SELECTOR_DRAWER), container))

    //Creating Object Classes
    this.swatches = new Swatch(this.container);

    //Selectors
    this.productMoney = container.find(PRODUCT_MONEY)[0];
    this.productCompare = container.find(PRODUCT_COMPARE_MONEY);
    this.alternatePaymentPrice = container.find(PRODUCT_ALTERNATE_PAYMENT_MONEY);
    this.stockNotice = container.find(STOCK_NOTICE_SELECTOR);
    this.soldOutMessage = container.find(SOLD_OUT_SELECTOR);
    this.bisNotifyBtn = container.find(BIS_NOTIFY_BTN);
    this.buyOptions = document.querySelector(SELECTOR_BUY_OPTIONS);
    this.alternatePaymentMethods = document.querySelector(SELECTOR_ALTERNATE_METHODS);
    this.configurationSelector = document.querySelector(SELECTOR_CONFIGURATION);
    this.customiseContainer = document.querySelector('[data-customise-container]')
    this.AddButton = document.querySelector('[data-add-to-cart-button]');
    this.variantID = this.container.find('input[data-variantid]').attr('data-variantid');
    this.productID = this.container.find('input[name="product-id"]').val();

    $(document).on(ON_VARIANT_CHANGE, (e, variant) => this.onVariantChanged(variant));
    

    console.dir(this)

    this.configSelection = 'single';
    this.configurationSelector?.addEventListener('change', e => {
      this.configSelection = e.target.value;
      this.customiseContainer.classList.toggle('single-config', this.isSingleConfig);    
      
      // Update price
      this.formatPrice()
    });

    this.buyOptions?.addEventListener('click',()=> {
      this.alternatePaymentMethods.classList.add(CLASS_VISIBLE);
    });

    const browserQuery = new URLSearchParams(window.location.search);
    // If product is a double set up, pre select all of the double product stuff
    if (browserQuery.has('double-product')) {
      this.configSelection = 'double';
      this.customiseContainer.classList.toggle('single-config', false); 
      this.configurationSelector.querySelector('#double-config').checked = true;
      this.formatPrice();
    }


    /**
     * Custoimiser launchButtons and upsellThumbnails are now referenced here.
    */

    // Setup Customiser Launch Buttons
    this.launchButtons = document.querySelectorAll('[data-customiser-launch]');
    this.launchButtons.forEach((btn) => {
      if(btn.getAttribute('data-customiser-launch') == this.productID) {
        btn.addEventListener('click', (e) => {
          const openCustomiser = new CustomEvent("open_customiser", {
            detail: {
              id: this.productID
            },
          });
          document.dispatchEvent(openCustomiser);
        });
      }
    });

    // Setup Double Customiser Launch Buttons
    this.upsellThumbnails = document.querySelectorAll('[data-upsell-thumbnail]');
    this.upsellThumbnails.forEach((thumb) => {
      const customiserId = thumb.getAttribute('data-upsell-thumbnail');
      const thumbButton = thumb.querySelector("[data-upsell-thumbnail-add]");
      const thumbSchema = thumb.querySelector("[data-upsell-thumbnail-schema]");
      if (!thumbButton || !thumbSchema) return;

      thumbButton.addEventListener("click", (e) => {
        e.preventDefault();
        const upgradeCustomiser = new CustomEvent("upgrade_customiser", {
          detail: {
            id: customiserId,
            schema: thumbSchema
          },
        });
        document.dispatchEvent(upgradeCustomiser);
      });
    });


    // Detect Query String and auto-launch customiser with single or double config
    // If Single - Open Single Customiser
    // If Double - Open 'Make it a double!' Modal
    const urlParams = new URLSearchParams(window.location.search);
    const SEL_SINGLE_CUSTOMISE = '[data-single-customise]';
    const SEL_DOUBLE_CUSTOMISE = '[data-double-customise]';
    const configSelector = document.querySelector('[data-configuration-selector]');
    const singleCustomiseButton = document.querySelector(SEL_SINGLE_CUSTOMISE);
    const doubleCustomiseBtn = document.querySelector(SEL_DOUBLE_CUSTOMISE);
    const doubleToggle = document.querySelector('#double-config');

    if (urlParams.has('double_customiser') && configSelector && doubleCustomiseBtn && doubleToggle) {
      doubleToggle.click();
      doubleCustomiseBtn.click();
    } else if (urlParams.has('single_customiser') && singleCustomiseButton) {
      setTimeout(() => {
        singleCustomiseButton.click();
      }, 1000);
    }


    // Add Button script updated so that any products that are not customisable / samples / will add to the cart. Previously it was breaking.
    // This may not be necessary but might be good to have a working add to cart button over a broken one.
    this.AddButton?.addEventListener('click', (e) => this.onAddBtnClick(e));

    // Set Default Product From Variant Landing
    document.querySelector('.c-product-details [data-swatch-object].is-selected')?.click();

  }

  get isSingleConfig() {
    return this.configSelection === 'single';
  }

  formatPrice() {
    const prodType = this.swatches.data.type;
    const basePrice = this.swatches.data.price_min;
    const amounts = {
      'Curtains': 35900,
      'Blinds': 7700
    };

    const price = this.isSingleConfig ? basePrice : basePrice + amounts[prodType];
    this.productMoney.textContent = `$${price / 100}`
  }

  onAddBtnClick(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const addBtn = e.currentTarget;
    this.addItemToCart(addBtn);
  }

  async addItemToCart(addBtn) {
    const variantID = this.variantID;
    const btnText = addBtn.querySelector('[data-add-to-cart-text]');
    let orginalText = btnText?.innerText;

    if(!variantID) console.log("No Var");
    if (!variantID) return;

    if (btnText) {
      addBtn.setAttribute('disabled', 'disabled');
      btnText.innerText = 'Adding...'
    }

    try {
      await cartAdd({
        items: [{
          id: parseInt(variantID),
          quantity: 1
        }]
      });

      setTimeout(() => {
        if (btnText && orginalText) {
          btnText.innerText = 'Added'
        }
      }, 500);
      
      setTimeout(() => {
        if (btnText && orginalText) {
          addBtn.removeAttribute('disabled');
          btnText.innerText = orginalText
        }
      }, 1500);
    } catch (e) {
      console.error('Failed to add to cart.');
      return;
    }
  }

  setVariantQueryString(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
  }

  onVariantChanged(variant) {
    let { price, compare_at_price, id, inventory_quantity, available } = variant;

    this.setVariantQueryString(id);

    if (this.AddButton) {
      this.AddButton.setAttribute(ATTR_SELECTED_VARIANT, id);
      if (!available) {
        this.AddButton.setAttribute('disabled', 'disabled');
        this.AddButton.classList.add('is-disabled');
      } else {
        this.AddButton.removeAttribute('disabled');
        this.AddButton.classList.remove('is-disabled');
      }
    }

    //Adjust Price Display
    if(!price || price <= 0) {
      this.productMoney.removeAttr("data-money");
      this.productMoney.html("FREE");
    } else {
      this.productMoney.getAttribute("data-money", price);
      this.productMoney.innerHTML = String(printMoney(price)).replace('.00','');
      this.alternatePaymentPrice.innerHTML = printMoney(price / 4, "money_format");
    }

    //Adjust compare price display
    if(!this.productCompare) return;
    if(!compare_at_price || compare_at_price <= price) {
      this.productCompare.removeAttr("data-money");
      this.productCompare.html("");
    } else {
      this.productCompare.attr("data-money", compare_at_price);
      this.productCompare.html(String(printMoney(compare_at_price)).replace('.00',''));
    }

    this.stockNotice.removeClass(CLASS_HIDDEN);

    //Update low stock message
    if(inventory_quantity > 0 && inventory_quantity <= 4) {
      let message = t('products.product.stock_message').replace('{{ remaining }}', inventory_quantity);
      this.stockNotice.html(message);
      this.stockNotice.addClass(CLASS_VISIBLE);
    } else {
      this.stockNotice.removeClass(CLASS_VISIBLE);
    }

    //sold out message & bis notify
    if (available) {
      this.soldOutMessage.addClass(CLASS_IS_HIDDEN);
      this.bisNotifyBtn.addClass(CLASS_IS_HIDDEN);
    } else {
      this.soldOutMessage.removeClass(CLASS_IS_HIDDEN);
      this.bisNotifyBtn.removeClass(CLASS_IS_HIDDEN);
    }
  }
}

$(() => $(PRODUCT_TEMPLATE_CONTAINER).each((i,e) => new ProductTemplate($(e))));